export default __webpack_public_path__ + "static/media/react.f9183dd2.svg";